import { HttpClientConfig, HttpClient } from "./HttpClient";
import { JSONAPIDocument } from "json-api-serializer";

export class Loader {
	constructor(private readonly apiURL: string) {}

	post<T = void>(config: HttpClientConfig): Promise<JSONAPIDocument> {
		return new HttpClient<T>({ baseURL: this.apiURL, ...config }).post();
	}

	get<T = void>(config: HttpClientConfig): Promise<JSONAPIDocument> {
		return new HttpClient<T>({ baseURL: this.apiURL, ...config }).get();
	}

	patch<T = void>(config: HttpClientConfig): Promise<JSONAPIDocument> {
		return new HttpClient<T>({ baseURL: this.apiURL, ...config }).patch();
	}

	delete<T = void>(config: HttpClientConfig): Promise<JSONAPIDocument> {
		return new HttpClient<T>({ baseURL: this.apiURL, ...config }).delete();
	}
}
